// Persists the v2 nav collapsed state across page loads. Nav links are full
// page navigations, so without this the panel would reset to expanded every
// time the supplier clicks through to another page. Read synchronously on init
// (by both the nav and the layout that offsets the content) to avoid a flash.
const STORAGE_KEY = 'sideNavV2:collapsed'

export const readNavCollapsed = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true'
  } catch {
    // Storage unavailable (e.g. disabled / private mode) — default to expanded.
    return false
  }
}

export const writeNavCollapsed = (collapsed) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, String(collapsed))
  } catch {
    // Storage unavailable — collapse state simply won't persist.
  }
}
